const createRecursiveFunction = (
  callback,
  options: {
    optTimeout?: number;
    condition(): void;
  },
) => {
  const fn = () => {
    if (options.condition()) {
      callback();
    } else {
      setTimeout(fn, options.optTimeout || 1000);
    }
  };

  return fn;
};

export default createRecursiveFunction;
